import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6b9d755e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=6b9d755e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d755e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9d755e')) {
      api.createRecord('6b9d755e', component.options)
    } else {
      api.reload('6b9d755e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6b9d755e&scoped=true&", function () {
      api.rerender('6b9d755e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/DiscountReport/Index.vue"
export default component.exports